import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';

import { BsModalRef } from 'ngx-bootstrap/modal/';
import { Subject } from 'rxjs';
import { ThemeSettingService } from '../services/theme-setting.service';
import { ThemeSetting } from '../objects/ThemeObject';
import { WorkspaceService } from '../services/workspace.service';
import { Action } from '../objects/DetailObject';

@Component({
  selector: 'app-detail-popup',
  templateUrl: './detail-popup.component.html',
  styleUrls: ['./detail-popup.component.css']
})
export class DetailPopupComponent implements OnInit {

  @HostListener("document:keydown", ["$event"])
    handleKeyup(event) {
      if (event.keyCode === 8 && event.target.tagName.toUpperCase() != "INPUT" && event.target.tagName.toUpperCase() != "TEXTAREA") {
        event.preventDefault();
      }
    }

  refresh: boolean = false;
  title: string;
  popTitle:string;
  loaderConfig: ThemeSetting;
  isBusy: boolean = false;
  height: number;
  actions: Action[] = [];
  currentAction: Action;
  public refreshDetail: Subject<boolean>;
  @Input() componentId: string;
  @Input() isPreview: boolean;

  constructor(public bsModalRef: BsModalRef, public themeSettingService: ThemeSettingService, private workspaceService: WorkspaceService) { }

  @ViewChild('modalBody') modalBody: ElementRef; 

  ngOnInit() {
    this.refreshDetail = new Subject<boolean>();
    this.loaderConfig = this.themeSettingService.getTheme();
  }

  hide() {
    this.bsModalRef.hide();
  }

  closeCard(){
    this.workspaceService.closeCard(this.componentId).subscribe(result => {
      //console.log(result);
      // if result == 1 ok
    });
    this.bsModalRef.hide();
  }

  setTitle($event){
    this.popTitle = $event;
  }

  handleLoading($event){
    this.height = this.modalBody.nativeElement.offsetHeight;
    this.isBusy = $event;
  }

  setActions(actions: Action[]){
    this.actions = actions;
  }

  setCurrentAction(action:Action){
    if (this.currentAction){
      if (this.currentAction.ActionName == action.ActionName){
        this.currentAction = null;
        setTimeout(() => {
          this.currentAction = action;
        })
      }
      else{
        this.currentAction = action;
      }
    }
    else{
      this.currentAction = action;
    }
  }
}
